export default __webpack_public_path__ + "static/media/bank_kbank.36d0277c.svg";